module.exports = __webpack_public_path__ + "img/devs-choice-cn.0108bf1.png";